import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import ProductSummaryMol from "@onestore/hel/dist/components/molecules/ProductSummaryMol"
import ProductSummarySimpleMol from "@onestore/hel/dist/components/molecules/ProductSummarySimpleMol"
import FormButton from "@gatsby-plugin-generic-page/components/FormButton"
import type { Formily } from "@gatsby-plugin-generic-page/fragments/formily"
import { usePrimaryButton } from "@gatsby-plugin-marketplace/components/ProductHeader/usePrimaryButton"
import type { SaleConfiguration } from "~/fragments/saleConfigurations"
import isEmpty from "~/lib/isEmpty"

interface PrimaryButtonProps {
  saleConfiguration: SaleConfiguration
  simple?: boolean
  formilyForm?: Formily[]
}

export function PrimaryButton({
  saleConfiguration,
  simple = false,
  formilyForm,
}: PrimaryButtonProps): ReactElement<PrimaryButtonProps> | null {
  const button = usePrimaryButton(saleConfiguration)

  if (simple && !isEmpty(button)) {
    return (
      <ProductSummarySimpleMol.Button
        text={button.text}
        title={button.title}
        onClick={button.onClick}
        isLoading={button.isLoading}
        href={button.href}
        rel="nofollow"
      />
    )
  }

  if (!isEmpty(formilyForm)) {
    return (
      <FormButton
        form={formilyForm}
        text={_t("marketplace.contactButton")}
        title={_t("marketplace.contactButton")}
        color="primary"
        size="big"
        isExpanded
      />
    )
  }

  if (!isEmpty(button)) {
    return (
      <ProductSummaryMol.PrimaryButton
        text={button.text}
        title={button.title}
        onClick={button.onClick}
        isLoading={button.isLoading}
        href={button.href}
        rel="nofollow"
      />
    )
  }

  return null
}
